import React from 'react';
import classNames from 'classnames';
import { DialogTitleComponentProps } from './DialogTitle';
import './DialogTitleText.less';


interface IDialogTitleTextProps extends DialogTitleComponentProps {
  className?: string;
  children: React.ReactNode;
}

export function DialogTitleText(props: IDialogTitleTextProps) {
  const titleTextClasses = classNames('dp-dialog-title-text', props.classes?.titleText);
  return (
    <h6 className={titleTextClasses} style={props.styles?.titleText} title={props.titleText}>
      {props.children}
    </h6>
  );
}
